// 人员培训
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
import columns from './columns'
const { WizSpin, WizButton, WizModal, WizCard } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header';
import ShiftReport from './shiftReport';
import RemarkForm from './components/addRemark';
import LookRemark from "./components/lookRemark";

const findParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/integrationCounseling/track/personnelTrain') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('trackPersonnelTrain', record)
    } else {
      record = Session.get('trackPersonnelTrain') || {}
    }
  }
  return record
}

class TrackPersonnelTrain extends WizContainer {

  componentName = 'TrackPersonnelTrain'

  constructor(props) {
    super(props)
    let record = findParamRecord(props.history)
    this.state = {
      record,
      visible: false,
      modalInfo: {},
      modalType: 1, // 1 报班情况 2 填写备注
      data: []
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/getTrackTrainingMapList',
      payload: {
        key: 'getTrackTrainingMapList@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId
        }
      }
    })
  }

  toUpdate = (type) => {
    const { processContentId, tutorId, orgId } = this.state.record
    this.doAction({
      path: 'counselingProcess/trackTrainingAdd',
      payload: {
        key: 'trackTrainingAdd@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId,
          orgId: orgId,
          type:type
        }
      }
    })
  }

  // 更新备注
  updateRemark = (params = {}) => {
    const { processContentId } = this.state.record
    const { id } = this.state.modalInfo
    this.doAction({
      path: 'counselingProcess/trainingUpdateRemark',
      payload: {
        key: 'trainingUpdateRemark@' + processContentId,
        apiParams: {
          id,
          ...params
        }
      }
    })
  }

  // 取消更新备注
  onCancelRemark = (params = {}) => {
    this._resetModal();
  }

  markConfirmed = () => {
    const { processContentId } = this.state.record
    this.doAction({
      path: 'counselingProcess/trackTrainingNoticeTargetConfirm',
      payload: {
        key: 'trackTrainingNoticeTargetConfirm@' + processContentId,
        apiParams: {
          tutorContentId: processContentId
        }
      }
    })
  }

  _onBtn = (type) => {
    switch (type) {
      case 1:
        WizModal.confirm({
          title: '注意',
          content: '人员培训信息即将更新，您是否需要清空已填写的备注信息？',
          okText: '需要',
          cancelText: '不需要',
          onOk: () => {
            this.toUpdate(1)
          },
          onCancel: () => {
            this.toUpdate(2)
          }
        })
        break
      case 2:
        WizModal.confirm({
          title: '注意',
          content: '是否确认进行达标确认操作？',
          onOk: () => {
            this.markConfirmed()
          },
          onCancel() {
          }
        })
        break
      default:
        break
    }
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this),
    markConfirmed: this._markConfirmed.bind(this),
    toUpdate: this._toUpdate.bind(this),
    updateRemark: this._updateRemark.bind(this)
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.data = data
      return true
    }
    wizNotice.error(msg || '获取人员培训列表失败')
    return false
  }

  _toUpdate(nextProps, nextState) {
    let { toUpdate } = nextProps
    let { success, msg } = toUpdate
    if (success) {
      wizNotice.success(msg)
      this.getList()
      return true
    }
    wizNotice.error(msg || '更新人员培训列表失败')
    return false
  }

  _markConfirmed(nextProps, nextState) {
    let { markConfirmed } = nextProps
    let { success, msg } = markConfirmed
    if (success) {
      wizNotice.success(msg)
      this.jumpPage('goBack')
      return true
    }
    wizNotice.error(msg || '达标确认失败')
    return false
  }

  _updateRemark(nextProps, nextState) {
    let { updateRemark } = nextProps
    let { success, msg } = updateRemark
    if (success) {
      wizNotice.success(msg)
      this._resetModal()
      this.getList()
      return true
    }
    wizNotice.error(msg || '备注失败')
    return false
  }

  /**
  * 达标确认按钮是否可用
  * 列表数据不为空，所有人员配置的线下课程有通过状态
  * 22-3-30 改为后台校验,data有内容,且未达标确认的开放按钮
  */
  _confirmationState = () => {
    let { data, record } = this.state
    let { processContentState } = record
    // let allTrackTrainingList = data.map(e => e.trackTrainingList) // 所有课程信息
    // let flatArr = allTrackTrainingList.flat() // 降维
    // let stateArr = flatArr.filter(e=>{
    //   return e.classResultStatus === 1 || e.remark
    // })
    // stateArr.length === flatArr.length 如相同,达标确认按钮可用
    return processContentState === 1 || data.length === 0
  }

  // 初始化弹窗
  _resetModal = () => {
    this.setState({ visible: false, modalInfo: {}, modalType: '' })
  }

  // modal弹出框
  _returnModalProps = () => {
    let { visible, modalType, modalInfo } = this.state
    return {
      title: modalType === 1 ? '报班情况' : modalType === 2 ? '填写备注' : '查看备注',
      visible,
      footer: null,
      width: modalType === 1 ? '90%' : 700,
      destroyOnClose: true,
      children: modalType === 1 ? <ShiftReport {...modalInfo} /> : modalType === 2 ? <RemarkForm addRemark={this.updateRemark} onCancelRemark={this.onCancelRemark}/> : <LookRemark {...modalInfo} />,
      onCancel: () => {
        this._resetModal()
      },
      afterClose: () => {
        this._resetModal()
      }
    }
  }

  /**
   *
   * @param {* 1 报班情况 2 填写备注} type
   * @param {*} row
   */
  _handleRowBtn = (type, row) => {
    let newModalInfo = {}
    switch (type) {
      case 1:
        let { positionPersonId } = row
        let { data } = this.state
        let filterInfo = data.filter(e => e.positionPersonId === positionPersonId)
        if (filterInfo.length === 0) {
          wizNotice.error('未匹配到positionPersonId')
          return false
        }
        newModalInfo = filterInfo[0]
        break
      case 2:
        let { id } = row
        newModalInfo = { id: id }
        break
      case 3:
        newModalInfo = { ...row }
        break
      default:
        break
    }
    this.setState({
      modalInfo: newModalInfo,
      modalType: type,
      visible: true
    })
  }

  render() {
    let { counselingProcessLoading } = this.props
    let { record, data, modalInfo } = this.state
    log.info('record',record);
    let { processContentState } = record
    let tableProps = {
      columns: columns(this._handleRowBtn,processContentState),
      dataSource: recombinationData(data),
      pagination: false,
      bordered: true,
      rowKey: (e, i) => i
    }

    return (
      <WizSpin spinning={counselingProcessLoading} >
        <CounselingHeader record={record} />
        <WizCard title='人员培训'>
          <div style={{ marginBottom: 20 }}>
            <WizButton
              type='primary'
              disabled={processContentState === 1}
              style={{ marginRight: 15 }}
              onClick={() => this._onBtn(1)}>
              {'更新'}
            </WizButton>
            <WizButton
              type='primary'
              disabled={this._confirmationState()}
              onClick={() => this._onBtn(2)}>
              {'达标确认'}
            </WizButton>
          </div>
          <Table {...tableProps} />
        </WizCard>

        <WizModal {...this._returnModalProps()} />
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const { processContentId } = findParamRecord(ownProps.history)
  const list = modelUtils.getModelEntity(counselingProcess, 'getTrackTrainingMapList@' + processContentId)
  const toUpdate = modelUtils.getModelEntity(counselingProcess, 'trackTrainingAdd@' + processContentId) // 更新
  const updateRemark = modelUtils.getModelEntity(counselingProcess, 'trainingUpdateRemark@' + processContentId) // 更新备注
  const markConfirmed = modelUtils.getModelEntity(counselingProcess, 'trackTrainingNoticeTargetConfirm@' + processContentId) // 达标确认
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    markConfirmed,
    toUpdate,
    updateRemark,
    ...loading
  }
}

export default connect(mapStateToProps)(TrackPersonnelTrain)

const recombinationData = (tableData) => {
  if (tableData.length === 0) return []
  let copyData = [...tableData]
  let newData = []
  copyData.map(e => {
    e.trackTrainingList.map((c, i) => {
      let obj = {
        rowSpan: i === 0 ? e.trackTrainingList.length : 0,
        ...c
      }
      newData.push(obj)
    })
  })
  return newData
}


